module.exports = __webpack_public_path__ + "static/header-alumni-triangle-6a1309680947f2eb3f37daac6a89da67.png";